/*global AUTHED_USER_SESSION, LAST_LOGIN_USERNAME, PRIVATE_LABEL_CONFIG, localStorage */
let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");
let doIHaveAccess = require("./doIHaveAccess");
let hasLocalstorage = require("has-localstorage");

let session_data =
  typeof AUTHED_USER_SESSION !== "undefined" ? AUTHED_USER_SESSION : {};
let last_login_username =
  typeof LAST_LOGIN_USERNAME !== "undefined" && _.isString(LAST_LOGIN_USERNAME)
    ? LAST_LOGIN_USERNAME
    : "";
let private_label_config =
  typeof PRIVATE_LABEL_CONFIG !== "undefined" ? PRIVATE_LABEL_CONFIG : {};
let st_usertype = _.get(session_data, "balboa.st_usertype", null);

let companyIdsICanRead = _.map(session_data.companies, (company) =>
  _.get(company, ["COMPANY_ID"])
); //used for team-admin privatelabels //TODO get from authentication data
let companyIdsICanWrite = _.map(session_data.companies, (company) =>
  _.get(company, ["COMPANY_ID"])
); //used for team-admin privatelabels //TODO get from authentication data
let selectedCompany = function () {
  let company = hasLocalstorage()
    ? _.parseInt(localStorage.getItem("lastSelectedCompany"), 10)
    : -1;
  return company;
};
let activeCompany = _.has(session_data.companies, [selectedCompany()])
  ? _.get(session_data.companies, [selectedCompany()])
  : !_.isNull(session_data.company)
  ? session_data.company
  : _.head(_.map(session_data.companies, (c) => c)); //the currently selected company; used for team-admin privatelabels
// _.set(private_label_config, ["privatelabel_code"], _.get(session_data, ["company", "abbreviation"]);
let activeCompanyIds = _.map(
  _.filter(
    session_data.companies,
    (company) =>
      _.get(company, ["COMPANY_ID"]) === _.get(activeCompany, ["COMPANY_ID"]) ||
      _.get(company, ["PARENT_ID"]) === _.get(activeCompany, ["COMPANY_ID"])
  ),
  (company) => _.get(company, ["COMPANY_ID"])
);

let packages = {
  STARTER: 7,
  PLUS: 6,
  PROFESSIONAL: 5,
  PRO: 5,
};

let getSIDsAtPackageLevel = function (level) {
  if (!_.isString(level) || !packages[level.toUpperCase()]) {
    return null;
  }
  let level_num = packages[level.toUpperCase()];
  return _.map(
    _.filter(
      _.pairs(_.mapValues(session_data.permissions, "version")),
      function (pair) {
        return pair[1] === level_num;
      }
    ),
    function (pair) {
      return _.parseInt(pair[0]);
    }
  );
};

let MY_USERNAME = _.get(session_data, "balboa.username");
MY_USERNAME = _.isString(MY_USERNAME) ? MY_USERNAME.trim().toUpperCase() : "";

let all_sids_i_have_permission_for = _.keys(session_data.permissions);
all_sids_i_have_permission_for = _.filter(
  all_sids_i_have_permission_for,
  (sid) => {
    let r = _.contains(
      _.get(session_data.permissions, [sid, "companies"], []),
      _.get(activeCompany, ["COMPANY_ID"])
    );
    return r;
  }
);

all_sids_i_have_permission_for = esUtils.cleanup_ids(
  all_sids_i_have_permission_for
);

module.exports = {
  MY_USERNAME,
  balboa: session_data.balboa || {},
  companies: session_data.companies || {},
  permissions: session_data.permissions || {},
  getSIDsAtPackageLevel,
  is_logged_in: !_.isEmpty(MY_USERNAME),
  last_login_username,
  all_sids_i_have_permissions_for: all_sids_i_have_permission_for,
  helpurl: private_label_config.helpurl,
  is_st_family:
    "es" !== _.get(activeCompany, ["ABBREVIATION"]) &&
    "cs" !== _.get(activeCompany, ["ABBREVIATION"]),
  is_st:
    "es" !== _.get(activeCompany, ["ABBREVIATION"]) &&
    "cs" !== _.get(activeCompany, ["ABBREVIATION"]) &&
    "st" == _.get(activeCompany, ["ABBREVIATION"]),
  is_cs: "cs" == _.get(activeCompany, ["ABBREVIATION"]),
  is_privatelabel: _.get(private_label_config, ["is_privatelabel"], false),
  privatelabel_code: _.get(
    activeCompany,
    ["ABBREVIATION"],
    _.get(private_label_config, ["privatelabel_code"])
  ),
  is_beta: !!private_label_config.is_beta,
  companyIdsICanWrite: companyIdsICanWrite,
  companyIdsICanRead: companyIdsICanRead,
  activeCompany: activeCompany,
  activeCompanyIds: activeCompanyIds,
  st_usertype,

  /**
   * This is the primary way of determining what permissions the logged in user has for given sid(s)
   *
   * doIHaveAccess.admin.all(sids) -> true/false
   *    - do you have admin level for ALL the sids?
   *
   * doIHaveAccess.admin.any(sids) -> true/false
   *    - do you have admin level for ANY of the sids?
   *
   * doIHaveAccess.admin.getSIDs() -> sids
   *    - get all the sids you have admin for
   *
   * You can swap out "admin" for any of the access levels defined in access_type_to_user_classes.
   */
  doIHaveAccess: doIHaveAccess(session_data, private_label_config),

  getLastSelectedSID() {
    if (session_data.is_st_family) {
      //ST wants to always default to -- all speakers --
      return 0;
    }

    //don't use esUtils.toInt b/c it defaults to 0 on NaN. We don't want it to default to all-speakers (sid===0)
    let sid = hasLocalstorage()
      ? _.parseInt(localStorage.getItem("lastSelectedSID"), 10)
      : -1;

    return _.has(session_data.permissions, sid) || sid === 0 //0 means all speakers
      ? sid
      : esUtils.toInt(_.first(_.keys(session_data.permissions)));
  },
  setLastSelectedSID(sid) {
    if (!hasLocalstorage()) {
      return; //no local storage, don't worry about it
    }
    localStorage.setItem("lastSelectedSID", sid);
  },
  getLastSelectedCompany: selectedCompany,
  setLastSelectedCompany(company) {
    if (!hasLocalstorage()) {
      return; //no local storage, don't worry about it
    }
    //console.log("Saving lastSelectedCompany: ", company);
    localStorage.setItem("lastSelectedCompany", company);
  },
};



// WEBPACK FOOTER //
// ./src/utils/AuthedUserSession.js